import { Button, Popover, Row } from "antd";
import { useLanguage } from "../../../../../../../context/LanguageContext";
import { LayoutShowSchema } from "../../../../../../../models/Warehouse";
import { EmptyPosition } from "../../../../../../../models/Sweep";
import { MAP_CELL_SIZE } from "../mapDimensions";

interface GridProps {
  rackTemplate: LayoutShowSchema;
  emptyZone: EmptyPosition | null;
}

const EmptyMap: React.FC<GridProps> = ({
  rackTemplate,
  emptyZone,
}) => {
  const { language } = useLanguage();

  const isInEmptyZone = (col: number, lvl: number) => {
    if (!emptyZone) return false;
    return (
      col >= emptyZone.col_from &&
      col <= emptyZone.col_to &&
      lvl >= emptyZone.level_from &&
      lvl <= emptyZone.level_to
    );
  };

  const renderGrid = () => {
    const grid = [];
    for (let i = rackTemplate.level_range[1]; i >= rackTemplate.level_range[0]; i--) {
      const row = [];
      const start = rackTemplate.orientation === "right"
        ? rackTemplate.column_range[1]
        : rackTemplate.column_range[0];
      const end = rackTemplate.orientation === "right"
        ? rackTemplate.column_range[0]
        : rackTemplate.column_range[1];
      const inc = rackTemplate.orientation === "right" ? -1 : 1;

      for (let j = start; rackTemplate.orientation === "right" ? j >= end : j <= end; j += inc) {
        const isIgnored = rackTemplate.ignore_cells?.some(([col, levels]) =>
          col === j && levels.includes(i)
        );
        const isEmpty = isInEmptyZone(j, i);

        row.push(
          <Popover title={`${language === "es" ? "Posición" : "Position"}: ${String(j).padStart(2, "0")}${i}`} key={`tooltip-${i}-${j}`}>
            <Button
              type="primary"
              size="small"
              style={{
                margin: "2px",
                width: `${MAP_CELL_SIZE}px`,
                height: `${MAP_CELL_SIZE}px`,
                padding: 0,
                backgroundColor: isIgnored ? "#bfbfbf" : isEmpty ? "#a0d911" : undefined,
              }}
              
            />
          </Popover>
        );
      }

      grid.push(
        <div key={`row-${i}`} style={{ display: "flex", justifyContent: "center" }}>
          {row}
        </div>
      );
    }

    return grid;
  };

  return (
    <Row style={{ flexDirection: "column", alignItems: "center", overflow: "scroll", width: "100%" }}>
      {renderGrid()}
    </Row>
  );
};

export default EmptyMap;
